// Centralized API and WebSocket configuration used by both CUSTOMER and AGENT flows

const DEV_API_BASE = "https://api-yeshtery.dev.meetusvr.com/v1";

// Prefer environment overrides if present, but default to the unified base provided
export const API_BASE = process.env.REACT_APP_BACKEND_BASE_URL || DEV_API_BASE;

// The socket lives on the same host as the API, at /ws instead of /v1. Deriving
// it from API_BASE means it always follows the environment's own backend: the
// build only sets REACT_APP_BACKEND_BASE_URL per environment, and a hardcoded
// socket default sent every environment — production included — to the dev
// socket. An explicit REACT_APP_WS_URL still wins if a build sets one.
const deriveWsUrl = (apiBase) =>
  apiBase.replace(/\/v1\/?$/, "").replace(/\/$/, "") + "/ws";

export const WS_URL = process.env.REACT_APP_WS_URL || deriveWsUrl(API_BASE);

// Assign object to a variable before exporting
const config = { API_BASE, WS_URL };
export default config;
